'use client';

import { useEffect, useRef, useState } from 'react';
import { photoVariant } from '@lib/photo';

/**
 * Foto de un trabajo en la variante justa (ver lib/photo.js). Si la variante no existe (fotos
 * subidas antes de que Cyclone las generara), vuelve al original una sola vez.
 */
export default function Photo({ src, size = 500, alt = '', eager = false, className, style }) {
  const [useOriginal, setUseOriginal] = useState(false);
  const ref = useRef(null);
  const url = useOriginal ? src : photoVariant(src, size);

  // Si la variante falló antes de hidratar, onError ya pasó: se detecta al montar.
  useEffect(() => {
    const img = ref.current;
    // Sincroniza con el DOM (un error que ocurrió antes de hidratar), no con estado de React.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    if (img && img.complete && img.naturalWidth === 0 && !useOriginal) setUseOriginal(true);
  }, [useOriginal]);

  if (!src) return null;
  return (
    <img
      ref={ref}
      src={url}
      alt={alt}
      loading={eager ? 'eager' : 'lazy'}
      decoding="async"
      className={className}
      style={style}
      onError={() => !useOriginal && setUseOriginal(true)}
    />
  );
}
